var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMinimizeButton = function SvgMinimizeButton(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.6,
    d: "M4.048 5.1c-.164 0-.298.139-.298.308v4.334c0 .17.134.308.298.308h4.354c.164 0 .298-.139.298-.308V5.409c0-.17-.134-.309-.298-.309H4.048h0z",
    transform: "translate(.125 .25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.033.5c.343 0 .656.12.882.32.203.178.335.423.335.698h0v10.464c0 .275-.132.52-.335.698-.226.2-.539.32-.882.32h0H1.717c-.343 0-.656-.12-.882-.32-.203-.178-.335-.423-.335-.698h0V1.518c0-.275.132-.52.335-.698.226-.2.539-.32.882-.32h0zm-.55.5H2.267c-.339 0-.644.122-.866.311-.254.216-.401.518-.401.843v9.192c0 .326.147.627.4.843.223.189.528.311.867.311h11.216c.339 0 .644-.122.866-.311.254-.216.401-.518.401-.843V2.155c0-.326-.147-.627-.4-.843-.223-.19-.528-.311-.867-.311z",
    transform: "translate(.125 .25)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMinimizeButton);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/minimize-button.b554322536bba2e8e561cd65abbe5487.svg";